import { render, staticRenderFns } from "./NewCategoryForm.vue?vue&type=template&id=44aa1010&"
import script from "./NewCategoryForm.vue?vue&type=script&lang=js&"
export * from "./NewCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports